export default __webpack_public_path__ + "static/consulting-22e1998d311a332109d63accc1e698f4.jpg";